import { render, staticRenderFns } from "./giftinfo.vue?vue&type=template&id=71f82361&scoped=true"
import script from "./giftinfo.vue?vue&type=script&lang=js"
export * from "./giftinfo.vue?vue&type=script&lang=js"
import style0 from "./giftinfo.vue?vue&type=style&index=0&id=71f82361&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f82361",
  null
  
)

export default component.exports